// @ts-ignore
import Markdown from "react-markdown";
import { PublicPageZip } from "@/utils/page";
import { JobGetResponse } from "@/types/job";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";
import SectionHeader from "@/components/Section/SectionHeader";
import Collapse from "@/components/UI/Collapse/Collapse";
// @ts-ignore
import remarkGfm from "remark-gfm";

interface Section21Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const FaqSection = ({ job, page, section, ...props }: Section21Props) => {
  return (
    <Section section={section} {...props}>
      <SectionContainer section={section}>
        <SectionHeader section={section} />
        <div className="flex flex-col items-center justify-center gap-10 lg:flex-row">
          {section?.CollapseList01?.length > 0 && (
            <div className="flex w-full flex-col gap-8 lg:w-1/2">
              {section?.CollapseList01Title && <div>{section?.CollapseList01Title}</div>}
              {section?.CollapseList01?.map((collapse: any) => {
                return (
                  <Collapse disabled={collapse?.Disabled} key={collapse?.id} title={collapse?.Title}>
                    <Markdown remarkPlugins={[remarkGfm]}>{collapse?.Content}</Markdown>
                  </Collapse>
                );
              })}
            </div>
          )}
          {section?.CollapseList02?.length > 0 && (
            <div className="flex flex-col gap-8">
              {section?.CollapseList02Title && <div>{section?.CollapseList02Title}</div>}
              {section?.CollapseList02?.map((collapse: any) => {
                return (
                  <Collapse disabled={collapse?.Disabled} key={collapse?.id} title={collapse?.Title}>
                    <Markdown remarkPlugins={[remarkGfm]}>{collapse?.Content}</Markdown>
                  </Collapse>
                );
              })}
            </div>
          )}
        </div>
      </SectionContainer>
    </Section>
  );
};

export default FaqSection;
